export const convertToBengaliNumber = (number) => {
  return String(number)
    .replace(/\./g, '.')  // Keep the decimal point as is
    .replace(/\d/g, d => '০১২৩৪৫৬৭৮৯'[d]);
}